import { render, staticRenderFns } from "./BackgroundSliderV2.vue?vue&type=template&id=fa1b5a1e"
import script from "./BackgroundSliderV2.vue?vue&type=script&lang=js"
export * from "./BackgroundSliderV2.vue?vue&type=script&lang=js"
import style0 from "./BackgroundSliderV2.vue?vue&type=style&index=0&id=fa1b5a1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports